import React from "react";

const StatusBadge = ({ status }) => {
  const isActive = status === "Active";

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 500,
        background: isActive ? "#dcfce7" : "#fee2e2",
        color: isActive ? "#16a34a" : "#dc2626",
      }}
    >
      {status}
    </span>
  );
};

const RoleBadge = ({ role }) => {
  const isEmployee = role === "Employee";

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 500,
        background: isEmployee ? "#dbeafe" : "#f3e8ff",
        color: isEmployee ? "#2563eb" : "#9333ea",
      }}
    >
      {role}
    </span>
  );
};

const UserTable = ({ data }) => {
  return (
    <div
      style={{
        marginTop: "20px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        overflow: "hidden",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead style={{ background: "#f9fafb" }}>
          <tr>
            {["Name", "Email", "Created Date", "Role", "Status"].map((head) => (
              <th
                key={head}
                style={{
                  textAlign: "left",
                  padding: "14px 16px",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#374151",
                }}
              >
                {head}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((user, index) => (
            <tr
              key={index}
              style={{
                borderTop: "1px solid #f1f5f9",
              }}
            >
              {/* Name + Avatar */}
              <td style={{ padding: "14px 16px", display: "flex", gap: "10px", alignItems: "center" }}>
                <img
                  src={user.avatar}
                  alt="avatar"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600 }}>
                    {user.name}
                  </div>
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>
                    {user.designation}
                  </div>
                </div>
              </td>

              {/* Email */}
              <td style={{ padding: "14px 16px", fontSize: "13px", color: "#374151" }}>
                {user.email}
              </td>

              {/* Date */}
              <td style={{ padding: "14px 16px", fontSize: "13px", color: "#374151" }}>
                {user.date}
              </td>

              {/* Role */}
              <td style={{ padding: "14px 16px" }}>
                <RoleBadge role={user.role} />
              </td>

              {/* Status */}
              <td style={{ padding: "14px 16px" }}>
                <StatusBadge status={user.status} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;